<template>
  <ui-modal
    v-model="showModal"
    :forcing="true"
    :header-title="title"
    :hide-overlay="false"
    :modal-width="width"
    :max-width="maxWidth"
    @close-icon-event="close"
  >
    <slot>
      <v-sheet class="wd-px-5 wd-py-3" min-height="142" max-height="60vh">
        <span>{{ content }}</span>
      </v-sheet>
    </slot>

    <template v-if="showButton" #buttons>
      <slot name="buttons">
        <div class="event-buttons-group wd-flex wd-justify-end wd-mt-2">
          <!-- 確認 -->
          <v-btn class="confirm-btn !wd-text-white" color="orange50" :min-width="66" :min-height="40" variant="flat" @click="confirm">
            {{ $t('all_ok') }}
          </v-btn>
        </div>
      </slot>
    </template>
  </ui-modal>
</template>

<script>
import { useVModel } from '@vueuse/core'
import UiModal from '@/components/dialog/ui-modal.vue'

export default defineComponent({
  components: {
    UiModal,
  },
  props: {
    title: { type: String, default: '' },
    modelValue: { type: Boolean, default: false },
    width: { type: [Number, String], default: 440 },
    maxWidth: { type: [Number, String], default: 600 },
    content: { type: String, default: '' },
    showButton: { type: Boolean, default: false },
  },
  emits: ['confirm', 'close', 'update:modelValue'],
  setup(props, ctx) {
    const showModal = useVModel(props, 'modelValue', ctx.emit)

    function confirm() {
      showModal.value = false
      ctx.emit('confirm')
    }

    function close() {
      ctx.emit('close')
    }

    return {
      showModal,
      confirm,
      close,
    }
  },
})
</script>
